/**
 * createBrowserPasskeyClient — ブラウザ向け PasskeyClient のワンショット組立てヘルパ。
 *
 * `@auth/client-passkey` の `createPasskeyClient` を `@auth/client` の `ApiClient` /
 * `BrowserStorage`（既定 prefix `auth_`）/ `createWebAuthnBridge()` で配線して返す。
 * これにより、各アプリは `createBrowserPasskeyClient({ baseUrl })` を 1 度呼んで
 * `AuthProvider` の `passkeyClient` prop に渡すだけで passkey ログインを有効化できる
 * （ダッシュボード専用だった配線を共有化）。
 *
 * トークン相互運用の不変条件:
 *   `BrowserStorage` は既定 prefix（`auth_`）で構築する。`AuthClient` が使う
 *   `auth_access_token` / `auth_refresh_token` と同一キーを共有し、signin 成功時に
 *   passkey client 内部が書き込むトークンをパスワード経路と相互運用可能にする。
 *   prefix を変更してはならない。
 */
import { ApiClient, BrowserStorage } from "@auth/client";
import { createPasskeyClient, createWebAuthnBridge } from "@auth/client-passkey";
/**
 * ブラウザ向けに配線済みの `PasskeyClient` を生成する。
 *
 * @param config.baseUrl auth backend のベース URL（`AuthClient` と同一）
 * @returns 配線済み PasskeyClient（`AuthProvider` の `passkeyClient` に渡す）
 */
export function createBrowserPasskeyClient(config) {
    // 不変条件: 既定 prefix（`auth_`）。keyPrefix を渡してはならない。
    const tokenStorage = new BrowserStorage({ storageType: "localStorage" });
    const apiClient = new ApiClient({
        baseUrl: config.baseUrl,
        getAccessToken: () => tokenStorage.getAccessToken(),
    });
    return createPasskeyClient({
        apiClient,
        webAuthnBridge: createWebAuthnBridge(),
        tokenStorage,
    });
}
